// Func = limiting Scope for this file
let lastScrollTop = 0;
let timeout;
let subtleParallaxEvents = [];

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function subtleParallax(el,index){

	let parallaxFunction = () => {
		let depth = el.dataset.depth;
		let move = window.pageYOffset * depth;
		el.style.transform = `translateY(${move}px)`;
		
	}

	subtleParallaxEvents[index] = parallaxFunction;
	window.addEventListener('scroll', subtleParallaxEvents[index]);
} 

(function(){

	let mainGallery = new LBX('.js-full-lbx', {});
	mainGallery.fullScreen = true;
	
	window.onload = function() {
		if(document.querySelector('.hero')) {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.querySelector('header').classList.add('down');
		}
	};

	
	// FORM focus animation
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//Links that open the menus:
	if(document.querySelectorAll('.js-go-to-link').length > 0){
		document.querySelectorAll('.js-go-to-link').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				let linkTarget = link.getAttribute('href');
				
				if(document.querySelector(`${linkTarget}`)){
					document.querySelector(`${linkTarget}`).scrollIntoView({ behavior: 'smooth' });
				}
			})
		})
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

})();

function tabsAndADA(){

	if(document.querySelectorAll('[role="tablist"]').length > 0 ){
		document.querySelectorAll('[role="tablist"]').forEach(tablist => {
			const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
			const panels = tabs.map(t => document.getElementById(t.getAttribute('aria-controls')));

			function activate(index, setFocus = true) {
				tabs.forEach((tab, i) => {
					const selected = i === index;
					tab.setAttribute('aria-selected', selected);
					tab.setAttribute('tabindex', selected ? '0' : '-1');
					panels[i].hidden = !selected;
					
				});
				if (setFocus) tabs[index].focus();
			}

			tablist.addEventListener('keydown', (e) => {
				const current = tabs.indexOf(document.activeElement);
				if (current < 0) return;
					let next = current;
					switch (e.key) {
					case 'ArrowRight': next = (current + 1) % tabs.length; break;
					case 'ArrowLeft':  next = (current - 1 + tabs.length) % tabs.length; break;
					case 'Home':       next = 0; break;
					case 'End':        next = tabs.length - 1; break;
					default: return;
				}
				e.preventDefault();
				activate(next);
			});

			tabs.forEach((tab, i) => tab.addEventListener('click', () => {
				activate(i);
				tab.focus();
				tabs.forEach( t => t.classList.remove('active'));
				tab.classList.add('active');
				if(document.querySelectorAll('.menus-block .menu-category .flex-box').length > 0){
					document.querySelectorAll('.menus-block .menu-category .flex-box').forEach( t => t.scrollTop = 0);
					document.querySelector('.menus-block').scrollTop = 0;
				}
			}));
		});
	}
	if(document.querySelectorAll('.faq-trigger').length > 0){
		const triggers = Array.from(document.querySelectorAll('.faq-trigger'));
		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const expanded = trigger.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(trigger.getAttribute('aria-controls'));
				trigger.setAttribute('aria-expanded', String(!expanded));
				panel.hidden = expanded;
				trigger.parentElement.classList.toggle('active');
			});

			trigger.addEventListener('keydown', (e) => {
				const i = triggers.indexOf(trigger);
				let next = i;
				switch (e.key) {
					case 'ArrowDown': next = (i + 1) % triggers.length; break;
					case 'ArrowUp':   next = (i - 1 + triggers.length) % triggers.length; break;
					case 'Home':      next = 0; break;
					case 'End':       next = triggers.length - 1; break;
					default: return;
				}
				e.preventDefault();
				triggers[next].focus();
			});
		});
	}
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 400){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}